import React, { useState, useEffect } from 'react';
import './PaymentPlanSelector.scss';

const PaymentPlanSelector = ({ training, onPlanSelect, selectedPlan: externalSelectedPlan }) => {
    const { TarifGlobal, Mensualites } = training.PageDePaiement;
    const [selectedPlan, setSelectedPlan] = useState(null);

    // ✅ Synchroniser avec le plan sélectionné depuis le parent
    useEffect(() => {
        if (externalSelectedPlan) {
            setSelectedPlan(externalSelectedPlan.type);
        }
    }, [externalSelectedPlan]);

    const handlePlanChange = (planType, planData) => {
        console.log('🎯 PaymentPlanSelector - Plan changed:', planType, planData);
        setSelectedPlan(planType);
        onPlanSelect({
            type: planType,
            data: planData
        });
    };

    // Plan global (paiement unique)
    const globalPlan = {
        type: 'global',
        amount: TarifGlobal,
        installments: 1,
        description: 'Paiement unique'
    };

    // Plans de mensualités
    const installmentPlans = Mensualites.map((mensualite, index) => ({
        type: `installment-${index}`,
        amount: mensualite.TarifParMois,
        installments: mensualite.NbMensualite,
        totalAmount: mensualite.TarifParMois * mensualite.NbMensualite,
        description: 'Sans frais'
    }));

    const allPlans = [globalPlan, ...installmentPlans];

    console.log('🎯 PaymentPlanSelector - Current selectedPlan:', selectedPlan);
    console.log('🎯 PaymentPlanSelector - External selectedPlan:', externalSelectedPlan);

    return (
        <div className="payment-plan-selector">
            <h3 className="payment-plan-selector__title">
                Choisis ton mode de paiement
            </h3>
            
            <div className="payment-plan-selector__plans">
                {allPlans.map((plan, index) => (
                    <div 
                        key={plan.type}
                        className={`payment-plan-selector__plan ${
                            selectedPlan === plan.type ? 'payment-plan-selector__plan--selected' : ''
                        }`}
                        onClick={() => handlePlanChange(plan.type, plan)}
                    >
                        <div className="payment-plan-selector__plan-header">
                            <input
                                type="radio"
                                name="paymentPlan"
                                value={plan.type}
                                checked={selectedPlan === plan.type}
                                onChange={() => handlePlanChange(plan.type, plan)}
                                className="payment-plan-selector__radio"
                            />
                            
                            <div className="payment-plan-selector__plan-info">
                                <div className="payment-plan-selector__plan-main">
                                    {plan.installments === 1 ? (
                                        // Plan unique
                                        <>
                                            <span className="payment-plan-selector__amount">
                                                {plan.amount}€
                                            </span>
                                            <span className="payment-plan-selector__description">
                                                {plan.description}
                                            </span>
                                        </>
                                    ) : (
                                        // Plans échelonnés  
                                        <>
                                            <span className="payment-plan-selector__amount">
                                                {plan.amount}€
                                            </span>
                                            <span className="payment-plan-selector__times">
                                                x {plan.installments}
                                            </span>
                                            <span className="payment-plan-selector__description">
                                                {plan.description}
                                            </span>
                                        </>
                                    )}
                                </div>
                                {plan.installments > 1 && (
                                    <div className="payment-plan-selector__plan-details">
                                        <span className="payment-plan-selector__total">
                                            Total : {plan.totalAmount}€
                                        </span>
                                    </div>
                                )}
                            </div>
                        </div>
                        {plan.installments > 1 && (
                            <div className="payment-plan-selector__plan-breakdown">
                                <div className="payment-plan-selector__timeline">
                                    {[...Array(plan.installments)].map((_, i) => (
                                        <div key={i} className="payment-plan-selector__installment">
                                            <span className="payment-plan-selector__installment-number">
                                                {i + 1}
                                            </span>
                                            <span className="payment-plan-selector__installment-amount">
                                                {plan.amount}€
                                            </span>
                                            <span className="payment-plan-selector__installment-date">
                                                {i === 0 ? 'Aujourd\'hui' : 
                                                 i === 1 ? 'Dans 1 mois' : 
                                                 `Dans ${i} mois`}
                                            </span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                ))}
            </div>
            
            <div className="payment-plan-selector__info">
                <p>💳 Paiements sécurisés par Stripe</p>
                <p>🔒 Vos données sont protégées</p>
            </div>
        </div>
    );
};

export default PaymentPlanSelector;